module.exports = __webpack_public_path__ + "img/东莞艾莱美.6780d93.png";